<template>
  <div>
    <button class="btn bg-info text-white" @click="emailContact" disabled>
      <i :class="actionButtonIcon"></i>
      {{ callToActionButtonLabel || 'Action' }}
    </button>
  </div>
</template>

<script>

export default {
  props: {
    contactId: {
      type: String,
      required: true
    },
    callToActionButtonLabel: {
      type: String,
      default: 'Send An Email'
    },
    actionButtonIcon: {
      type: String,
      default: 'fa fa-paper-plane'
    }
  },
  data() {
    return {
      locale: this.$i18n.locale,
    };
  },
  methods: {
    emailContact() {
      this.$router.push(`/owner/${this.contactId}/email`);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/EmailContactButton.vue